export function calcImportanceScore(magnitude, sentiment) {
  if (magnitude === null || sentiment === null) return null;

  return magnitude * sentiment;
}
